import { render, staticRenderFns } from "./CourseListEditor.vue?vue&type=template&id=f6ed3808&"
import script from "./CourseListEditor.vue?vue&type=script&lang=js&"
export * from "./CourseListEditor.vue?vue&type=script&lang=js&"
import style0 from "./CourseListEditor.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports